import { parseHeatingRef, parseManagementRef } from '@/utils/scanner';

type RefParser = (ref: string) => {month: string; year: string; invoiceNumber: string} | null;

interface ServiceTypeProps {
  taxRate: number;
  invoiceId: string;
  refParser: RefParser;
  daysDue: number | null;
}

export default class ServiceType implements ServiceTypeProps {
  static readonly MANAGEMENT = new ServiceType('MANAGEMENT', 0.25, 'PP/K1', parseManagementRef, 15);

  static readonly HEATING = new ServiceType('HEATING', 0.05, 'PP/K2', parseHeatingRef, null);

  // private to disallow creating other instances of this type
  // eslint-disable-next-line no-useless-constructor
  private constructor(
    private readonly key: string,
    public readonly taxRate: number,
    public readonly invoiceId: string,
    public readonly refParser: RefParser,
    public readonly daysDue: number | null,
    // eslint-disable-next-line no-empty-function
  ) {
  }

  toString() {
    return this.key;
  }
}
